import React from "react";

export default function ChunkyMenuToggle({ isOpen, toggleMenu }) {
  return (
    <button
      onClick={toggleMenu}
      aria-label="Toggle Menu"
      className="h-14 px-6 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center transition duration-300"
    >
      <div
        className={`relative flex flex-col items-center justify-center ${
          isOpen ? "gap-0" : "gap-[10px]"
        }`}
      >
        {/* Top bar - hidden without affecting layout */}
        <div
          className={`w-12 h-[1.5px] bg-white transition-all duration-300 ${
            isOpen ? "opacity-0 absolute" : "opacity-100 static"
          }`}
        />

        {/* Bottom bar - always shown */}
        <div className="w-12 h-[1.5px] bg-white transition-all duration-300" />
      </div>
    </button>
  );
}
